export default "/images/chevrons-right.svg?675f5302ca57b814609822c480de79f1";